import React from "react";
import {VariableSizeList} from "react-window";

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
    const outerProps = React.useContext(OuterElementContext);
    return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
}

function renderRow(props) {
    const {data, index, style} = props;
    return React.cloneElement(data.items[index], {
        style: {
            ...style,
            top: style.top + data.padding,
        },
    });
}

// Adapter for react-window
const AutocompleteListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
    const {children, itemSize = 44, listBoxPadding = 8,  ...other} = props;
    const itemData = React.Children.toArray(children);
    const itemCount = itemData.length;

    const getHeight = () => {
        if (itemCount > 8) {
            return 8 * itemSize;
        }
        return itemData.map(() => itemSize).reduce((a, b) => a + b, 0);
    };

    const gridRef = useResetCache(itemCount);

    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    itemData={{items:itemData, padding:listBoxPadding}}
                    height={getHeight() + 2 * listBoxPadding}
                    width="100%"
                    ref={gridRef}
                    outerElementType={OuterElementType}
                    innerElementType="ul"
                    itemSize={() => itemSize}
                    overscanCount={5}
                    itemCount={itemCount}
                >
                    {renderRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    );
});

export default AutocompleteListboxComponent;